import React, { memo } from 'react'
import { Box, CircularProgress } from '@mui/material'

type Props = {
    size?: number | string
}
const Loading = ({ size = 50 }: Props) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <CircularProgress size={size} />
        </Box>
    )
}

export default memo(Loading)